import { Chip } from "components/DesignSystem/Chips/Chips";
import { Filter } from "components/DesignSystem/Filter/Filter";
import {
  FilingsFilter,
  StateFilter,
  TagFilter,
  TaskServiceTeamFilter,
} from "components/tasks/taskForForeignCA/ForeignCATaskFilter";
import { useFilters } from "hooks/useFilter";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const OldTaskListFilter = () => {
  const { isCpa } = useRoleBasedView();
  const { values, updateFilter } = useFilters({
    initialValue: {
      states: [] as string[],
      filings: [] as string[],
      tags: [] as string[],
      service_teams: [] as string[],
    },
    useQueryParams: true,
  });

  return (
    <Filter.Root
      defaultValue="states"
      capsule={
        <>
          {values.states.length > 0 && (
            <Chip
              onRemove={() => updateFilter("states", [])}
              isActive
              filterType="states"
            >
              States ({values.states.length})
            </Chip>
          )}
          {values.filings.length > 0 && (
            <Chip
              onRemove={() => updateFilter("filings", [])}
              isActive
              filterType="filings"
            >
              Filings ({values.filings.length})
            </Chip>
          )}
          {isCpa && values.tags.length > 0 && (
            <Chip
              onRemove={() => updateFilter("tags", [])}
              isActive
              filterType="tags"
            >
              Tags ({values.tags.length})
            </Chip>
          )}
          {isCpa && values.service_teams.length > 0 && (
            <Chip
              onRemove={() => updateFilter("service_teams", [])}
              isActive
              filterType="service_teams"
            >
              Service Teams ({values.service_teams.length})
            </Chip>
          )}
        </>
      }
    >
      <Filter.Portal>
        <Filter.List>
          <Filter.ListItem value="states">States</Filter.ListItem>
          <Filter.ListItem value="filings">Filings</Filter.ListItem>
          {isCpa && (
            <>
              <Filter.ListItem value="tags">Tags</Filter.ListItem>
              <Filter.ListItem value="service_teams">
                Service Teams
              </Filter.ListItem>
            </>
          )}
        </Filter.List>

        <Filter.Body value="tags" block>
          <TagFilter
            selectedTag={values.tags.join(",")}
            onUpdate={(values) => {
              updateFilter("tags", values);
            }}
          />
        </Filter.Body>
        <Filter.Body value="service_teams" block>
          <TaskServiceTeamFilter
            selectedTeams={values.service_teams.join(",")}
            onUpdate={(values) => updateFilter("service_teams", values)}
          />
        </Filter.Body>
        <Filter.Body value="filings" block>
          <FilingsFilter
            selectedTemplateFilter={values.filings.join(",")}
            onUpdate={(values) => updateFilter("filings", values)}
          />
        </Filter.Body>
        <Filter.Body value="states" block>
          <StateFilter
            onUpdate={(values) => updateFilter("states", values)}
            selectedStateFilter={values.states.join(",")}
          />
        </Filter.Body>
      </Filter.Portal>
    </Filter.Root>
  );
};
